module.exports = __webpack_public_path__ + "img/创建会话.03f73845.gif";